"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasView = void 0;
var next_1 = require("@hackforplay/next");
var csstips = require("csstips/lib");
var React = require("react");
var recoil_1 = require("recoil");
var lib_1 = require("typestyle/lib");
var recoils_1 = require("../recoils");
var useDropper_1 = require("../recoils/useDropper");
var cursor_1 = require("../utils/cursor");
var updateScene_1 = require("../utils/updateScene");
var Paper_1 = require("./Paper");
var cn = {
    root: lib_1.style(csstips.flex1, {
        padding: 16,
        paddingLeft: 0,
        paddingTop: 8,
        overflow: 'hidden'
    }),
    renderRoot: lib_1.style({
        width: '100%',
        height: '100%',
        padding: 16,
        boxSizing: 'border-box',
        overflow: 'scroll'
    }),
    scroller: lib_1.style({
        paddingRight: 100,
        paddingBottom: 100,
        boxSizing: 'content-box',
        position: 'relative'
    }),
    mainCanvas: lib_1.style({
        position: 'absolute',
        left: 0,
        top: 0
    }),
    nibCanvas: lib_1.style({
        position: 'absolute',
        zIndex: 1,
        pointerEvents: 'none',
        left: 0,
        top: 0
    }),
    disableTouchAction: lib_1.style({
        /**
         * https://developer.mozilla.org/en-US/docs/Web/CSS/touch-action
         * iOS 11 Safari では 'manipulation' だと Double Tap Zoom を防げなかった
         */
        touchAction: 'none'
    })
};
function CanvasView() {
    var _this = this;
    var cursorMode = recoil_1.useRecoilValue(recoils_1.cursorModeState);
    var nibLoadable = recoil_1.useRecoilValueLoadable(recoils_1.paletteNibState);
    var preloaded = recoil_1.useRecoilValueLoadable(recoils_1.preloadNibState);
    var cursor = cursorMode === 'pen' && preloaded.state !== 'hasValue'
        ? cursor_1.cursorClasses.nope // not-allowed
        : cursor_1.cursorClasses[cursorMode];
    var _a = recoil_1.useRecoilValue(recoils_1.sceneScreenState), width = _a.width, height = _a.height;
    var canvasRendererRef = React.useRef();
    var containerRef = React.useRef(null);
    React.useEffect(function () {
        var container = containerRef.current;
        if (!container || canvasRendererRef.current)
            return;
        canvasRendererRef.current = new next_1.CanvasRenderer(container, {
            width: width,
            height: height
        });
    }, [containerRef.current]);
    // ペン先または消しゴムの範囲を示すための Canvas
    var nibCanvasRef = React.useRef(null);
    var updateNibCanvas = recoil_1.useRecoilCallback(function (_a, _b) {
        var getLoadable = _a.getLoadable;
        var x = _b.x, y = _b.y;
        return __awaiter(_this, void 0, void 0, function () {
            var canvas, ctx, loadable, _c, cols, rows;
            return __generator(this, function (_d) {
                canvas = nibCanvasRef.current;
                ctx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext('2d');
                if (!canvas || !ctx)
                    return [2 /*return*/];
                loadable = getLoadable(recoils_1.cursorSizeState);
                if (loadable.state !== 'hasValue')
                    return [2 /*return*/];
                _c = loadable.contents, cols = _c.cols, rows = _c.rows;
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.strokeStyle = '#333';
                ctx.strokeRect(x * 32, y * 32, 32 * cols, 32 * rows);
                return [2 /*return*/];
            });
        });
    }, [nibCanvasRef.current]);
    var clearNibCanvas = React.useCallback(function () {
        var canvas = nibCanvasRef.current;
        var ctx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext('2d');
        if (!canvas || !ctx)
            return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    }, [nibCanvasRef.current]);
    var scene = recoil_1.useRecoilValue(recoils_1.sceneState);
    React.useEffect(function () {
        var canvasRenderer = canvasRendererRef.current;
        if (!canvasRenderer)
            return;
        canvasRenderer.update(scene);
    }, [scene]);
    var _b = __read(React.useState({
        px: -1,
        py: -1,
        pressed: false,
        id: 0
    }), 1), mutate = _b[0];
    var start = React.useCallback(function () {
        mutate.px = -1;
        mutate.py = -1;
        mutate.pressed = true;
        mutate.id++;
    }, []);
    var update = React.useCallback(function (x, y) {
        mutate.px = x;
        mutate.py = y;
    }, []);
    var stop = React.useCallback(function () {
        mutate.pressed = false;
        clearNibCanvas();
    }, []);
    var setDropper = useDropper_1.useDropper();
    var setEditing = recoil_1.useSetRecoilState(recoils_1.editingState);
    var handleMove = recoil_1.useRecoilCallback(function (_a, e) {
        var getLoadable = _a.getLoadable;
        var _b = e.currentTarget.getBoundingClientRect(), left = _b.left, top = _b.top;
        var x = ((e.clientX - left) / 32) >> 0;
        var y = ((e.clientY - top) / 32) >> 0;
        updateNibCanvas({ x: x, y: y });
        if (!mutate.pressed)
            return;
        if (nibLoadable.state !== 'hasValue')
            return;
        if (cursorMode === 'pen' && preloaded.state !== 'hasValue') {
            return; // Nib のロードが完了していない
        }
        if (cursorMode === 'dropper') {
            // スポイトで色を吸い取る
            setDropper(x, y);
            stop();
        }
        else if (x !== mutate.px || y !== mutate.py) {
            update(x, y);
            var eraserLoadable = getLoadable(recoils_1.eraserWidthState);
            var cursor_2 = new cursor_1.default(x, y, cursorMode, nibLoadable.contents, mutate.id, eraserLoadable.state === 'hasValue' ? eraserLoadable.contents : 1);
            setEditing(function (current) { return updateScene_1.editWithCursor(current, cursor_2); });
        }
    }, [cursorMode, nibLoadable, preloaded]);
    var handleMouseDown = React.useCallback(function (e) {
        start();
        handleMove(e);
    }, [handleMove]);
    React.useEffect(function () {
        window.addEventListener('mouseup', stop, { passive: true });
        return function () {
            window.removeEventListener('mouseup', stop);
        };
    }, []);
    var handleTouchMove = recoil_1.useRecoilCallback(function (_a, e) {
        var getLoadable = _a.getLoadable;
        var primary = e.touches.item(0);
        var _b = e.currentTarget.getBoundingClientRect(), left = _b.left, top = _b.top;
        var x = ((primary.clientX - left) / 32) >> 0;
        var y = ((primary.clientY - top) / 32) >> 0;
        updateNibCanvas({ x: x, y: y });
        if (!mutate.pressed)
            return;
        if (nibLoadable.state !== 'hasValue')
            return;
        if (cursorMode === 'pen' && preloaded.state !== 'hasValue') {
            return; // Nib のロードが完了していない
        }
        e.nativeEvent.preventDefault(); // 指でスクロールするのを防ぐ
        if (x !== mutate.px || y !== mutate.py) {
            update(x, y);
            var eraserLoadable = getLoadable(recoils_1.eraserWidthState);
            var cursor_3 = new cursor_1.default(x, y, cursorMode, nibLoadable.contents, mutate.id, eraserLoadable.state === 'hasValue' ? eraserLoadable.contents : 1);
            setEditing(function (current) { return updateScene_1.editWithCursor(current, cursor_3); });
        }
    }, [cursorMode, nibLoadable, preloaded]);
    var handleTouchStart = React.useCallback(function (e) {
        start();
        handleTouchMove(e);
    }, [handleTouchMove]);
    // Disable scroll on mobile browser
    var canvasRef = React.useRef(null);
    React.useEffect(function () {
        var canvas = canvasRef.current;
        if (!canvas)
            return;
        canvas.ontouchmove = function (e) { return e.preventDefault(); };
    }, [canvasRef.current]);
    return (React.createElement("div", { className: cn.root },
        React.createElement(Paper_1.Paper, { id: "rme-canvas-view", className: cn.renderRoot, ref: containerRef },
            React.createElement("div", { style: {
                    width: width,
                    height: height
                }, className: cn.scroller },
                React.createElement("canvas", { className: lib_1.classes(cursor, cn.disableTouchAction, cn.mainCanvas), width: width, height: height, onTouchStart: handleTouchStart, onTouchCancel: stop, onTouchEnd: stop, onTouchMove: handleTouchMove, onMouseDown: handleMouseDown, onMouseUp: stop, onMouseMove: handleMove, onMouseLeave: stop }),
                React.createElement("canvas", { className: cn.nibCanvas, width: width, height: height, ref: nibCanvasRef })))));
}
exports.CanvasView = CanvasView;
//# sourceMappingURL=CanvasView.js.map